export interface SvgIconProps {
  src: string;
  color?: Color;
  size?: Size;
  className?: string;
  dataTestId?: string;
}

export enum Size {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum Color {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  WHITE = 'WHITE',
  DISABLED = 'DISABLED',
}

export const SvgTheme: {
  size: Record<Size, string>;
  color: Record<Color, string>;
} = {
  size: {
    [Size.SMALL]: 'w-3 h-3',
    [Size.MEDIUM]: 'w-4 h-4',
    [Size.LARGE]: 'w-5 h-5',
  },
  color: {
    [Color.PRIMARY]: 'text-primary-600',
    [Color.SECONDARY]: 'text-neutral-600',
    [Color.TERTIARY]: 'text-neutral-400',
    [Color.SUCCESS]: 'text-green-400',
    [Color.WARNING]: 'text-yellow-500',
    [Color.DANGER]: 'text-pinkRed-500',
    [Color.WHITE]: 'text-neutral-50',
    [Color.DISABLED]: 'text-neutral-950-opacity-60',
  },
};
